'use strict';

const brazeEvents = require('constants');

const handleSubscriptionGroupId = (subscriptionGroupId) => {
    try {
        return JSON.parse(subscriptionGroupId);
    } catch (e) {
        return {};
    }
};

const brazeInstance = () => {
    const brazeData = window.brazeSdk;

    if (!brazeData) {
        console.error('Braze SDK data is not available.');
        return null;
    }

    const subscriptionGroupId = handleSubscriptionGroupId(brazeData.subscriptionGroupId);

    return new window.BrazeSdkService(
        brazeData.siteId,
        subscriptionGroupId,
        brazeData.url,
        brazeData.key,
        brazeData.enableSdkLogging
    );
};

const braze = brazeInstance();

const setup = (email = null) => {
    const isInitialized = braze.setup(email);

    if (isInitialized) {
        window.brazeSdk.isInitialized = true;
        document.body.dispatchEvent(new CustomEvent(brazeEvents.BRAZE.EVENTS.initialize));
    }
};

const handleUserChange = (userData) => {
    braze.changeUser(userData.detail.email);
};

const initializeEvents = (userData) => {
    const localData = braze.getLocalData();
    // prefer logged in email over potentially separate email set in localStorage
    const email = userData.email || localData.braze_id;
    window.addEventListener('load', () => {
        if (email) {
            setup(email.toLowerCase());
        } else {
            setup();
        }
    });

    document.body.addEventListener(brazeEvents.BRAZE.EVENTS.initialize, () => {
        [brazeEvents.BRAZE.EVENTS.subscribed, brazeEvents.BRAZE.EVENTS.enteredCheckout].forEach((eventType) => {
            document.body.addEventListener(eventType, handleUserChange);
        });

        [brazeEvents.BRAZE.EVENTS.addToBag, brazeEvents.BRAZE.EVENTS.updateQuantity, brazeEvents.BRAZE.EVENTS.removedFromCart].forEach(
            (eventType) => {
                document.body.addEventListener(eventType, (data) => {
                    braze.logCustomEvent(brazeEvents.BRAZE_LOG_EVENTS[eventType], {
                        platform: 'web',
                        name: data.detail.productName,
                        id: data.detail.productId,
                        quantity: data.detail.productQuantity
                    });
                });
            }
        );
    });

    document.body.addEventListener(brazeEvents.BRAZE.EVENTS.viewPLP, (data) => {
        braze.logCustomEvent(brazeEvents.BRAZE_LOG_EVENTS[brazeEvents.BRAZE.EVENTS.viewPLP], {
            platform: 'web',
            name: data.detail.categoryName,
            id: data.detail.categoryId,
            products: data.detail.productIdList
        });
    });
};

module.exports = {
    initializeEvents
};
